<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <!-- <md-dialog-title class = "heading" v-if="mode==='UPDATE'">Appointment</md-dialog-title> -->
      <md-dialog-title class = "heading">Check-In Summary!</md-dialog-title>

      <md-dialog-content >
<table id= "confirmData">    
          <tr>
            <th>IBS:</th>
            <td>{{dataForm.inboundShipment}}</td>
          </tr>
          <tr>
            <th>Appointment:</th>
            <td>{{dataForm.apptDate}}</td>
          </tr>
          <tr>
            <th>Driver Name:</th>
            <td>{{dataForm.moveInBy}}</td>
          </tr>
          <tr>
            <th>Driver Phone:</th>
            <td>{{dataForm.driverPh}}</td>
          </tr>
          <tr>
            <th>License Plate:</th>
            <td>{{dataForm.driverLP}}</td>
          </tr>
          <tr>
            <th>Trailer Number:</th>
            <td>{{dataForm.containerNo}}</td>
          </tr>
          <tr>
            <th>Checkin Time:</th>
            <td>{{dataForm.ciDate}}</td>
          </tr>
        </table>


        <dir hight= 20px></dir>
        <dir class = "Statements">***** MUST READ *****</dir>
        <dir class = "Statements">*Do not come to the warehouse until you are called to scale.</dir>
        <dir class = "Statements">*Do not double park and block the roads while you await our call. </dir>
        <dir class = "Statements">*Find legal parking in the area.</dir>
        <dir class = "Statements">*Long Beach Police Department will take enforcement action against illegal parking.</dir>
        <dir class = "Statements">*Please call (562)495-1936 to confirm yor check in!</dir>
        <dir class = "Statements">*We have frequently updated our web check-in portal. Please close your browser once you finish check-in, to apply the most updated function.</dir>
         


        <div class = "heading">
            <md-dialog-actions >
              <md-button class="md-raised custButtonForm " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
            </md-dialog-actions>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
@import '../../public/chrisForm.css';

form {
    min-width: 640px;
    margin: 5px;
    color: #000000;
    font-size: 24px;
  }

.heading {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: #000292;
    width: 92%;
    line-height: 2;
    font-size: 24px;
    font-family: Roboto Slab;
    margin-left: 10px;
  }

.Statements {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: rgb(255, 0, 0);
    width: 100%;
    font-size: 16px;
    font-family: Roboto Slab;
    margin: 0;
    text-align: left;
  }

#confirmData {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  margin-top: 10px;
  margin-left: 0px;
}
#confirmData th{
  text-align: left;
}
#confirmData td{
  padding-left: 10px;
}



</style>

<script>
  import { mapGetters } from 'vuex';
  import callingApiCenter from "./CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import api from '../api';
  import moment from 'moment';
  import dateFormat from '../utils/dateFormat';

  const getInitialdataForm = () => ({
    mode: "APPTC",
    username: null,
    apptDate: null,
    apptNo: null,
    apptSeq: null,
    inboundShipment: null,
    inboundStatus: null,
    inboundSeq: null,
    moveInBy: null,
    driverPh: null,
    driverLP: null,
    containerNo: null,
    block: null,
    receivingWindows: null,
    ciDate: null,
    loadRemark: null,
    
  });

  export default {
    components: { 

    },
    props: {
      
    },

    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
        
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
    },

    validations: {
      dataForm: {
      
      },
    },

 
    methods: {

      openDialog(existingUser) {
        this.$store.commit('clearApiError');
       
       
        this.$v.dataForm.$reset();

        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
      
        if (existingUser) {
          
          console.log(existingUser);
            this.dataForm.mode = existingUser.mode
            this.dataForm.username = existingUser.username
            this.dataForm.apptNo = existingUser.apptNo
            this.dataForm.apptSeq = existingUser.apptSeq
            this.dataForm.inboundShipment = existingUser.inboundShipment
            this.dataForm.inboundStatus = existingUser.inboundStatus
            this.dataForm.checkIn = existingUser.checkIn
            this.dataForm.inboundSeq = existingUser.seqNo
            this.dataForm.moveInBy = existingUser.moveInBy
            this.dataForm.driverPh = existingUser.driverPh
            this.dataForm.driverLP = existingUser.driverLP
            this.dataForm.containerNo = existingUser.containerNo
            this.dataForm.apptDate = dateFormat.gstDT(existingUser.apptDate)
            this.dataForm.block = existingUser.block
            this.dataForm.receivingWindows = existingUser.receivingWindows
            this.dataForm.ciDate = dateFormat.gstDT(existingUser.ciDate)
            this.dataForm.loadRemark = existingUser.loadRemark      
        }

        this.showDialog = true;
      },


      cancalAction(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },
          
      
    },
  };
</script>
